import React, { useCallback } from 'react'

// interfaces / constants
import { FEED_POST_TYPE_EVENT } from 'src/constants/feed'

// components
import PostCreateBanner from 'src/components/post/create/create_banner'

// helpers
import { useGlobalPermissions } from '@lopo-tech/lopo-api'
import PostCreate from 'src/containers/post/create'
import { textResources } from 'src/lang/de'

const labels = textResources.postCreate

export const useGetRenderEventCreate = (isPostCreateOpen: boolean) => {
  const { canCreateEvent } = useGlobalPermissions()

  const postType = FEED_POST_TYPE_EVENT
  return useCallback((): JSX.Element => {
    return (<>
      <PostCreateBanner
        postType={postType}
        callToActionText={labels.createEventTitle}
        featureBlocked={!canCreateEvent}
      />
      <PostCreate
        key='-1'
        open={isPostCreateOpen}
        postType={postType}
        featureBlocked={!canCreateEvent}
      />
    </>)
  }, [canCreateEvent, isPostCreateOpen, postType])
}
